import { Link } from "react-router-dom";

/** Where to get the app, and the way in for anyone who already has an account. */
export function AppPage() {
  return (
    <div className="splitter">
      <h1 className="wordmark big">Gymquisition</h1>
      <div className="stack">
        <a
          className="pill"
          href="https://apps.apple.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Download on the App Store
        </a>
        <a
          className="pill"
          href="https://play.google.com/store/apps/details?id=com.dreamsphere.gymquisition"
          target="_blank"
          rel="noreferrer noopener"
        >
          Get it on Google Play
        </a>
        <Link className="pill primary" to="/workout">
          Workout
        </Link>
      </div>
      <Link className="back" to="/">
        ← Back
      </Link>
    </div>
  );
}
